import {
  FlexBox,
  SanitizedTrimmedHtml,
} from '@airship-platform/jam-web/components';
import { BrokenPipeIcon } from '@airship-platform/jam-web/icons';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Appointment } from '../../../../data-access/appointments';
import AudioPlayer from './AudioPlayer';

type OverviewProps = {
  job: Appointment['job'];
};

const Overview: React.FC<OverviewProps> = ({ job }) => (
  <Box>
    <Typography variant="h4" sx={{ mb: 3 }}>
      Job Overview
    </Typography>
    <FlexBox
      flexDirection={['column', 'column', 'row']}
      alignItems={'flex-start'}
      gap={3}
    >
      <FlexBox flexDirection={'column'} gap={2} flex={1}>
        <FlexBox gap={2} alignItems={'center'}>
          <FlexBox alignSelf={'flex-start'}>
            <BrokenPipeIcon height={60} />
          </FlexBox>
          <FlexBox flexDirection={'column'} gap={0.5}>
            <Typography variant="caption">Reason for call</Typography>
            <SanitizedTrimmedHtml
              html={job.summary}
              hideAirshipLogo={true}
              variant="subtitle1"
            />
          </FlexBox>
        </FlexBox>
      </FlexBox>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          maxWidth: ['none', 'none', 300],
          width: ['100%', '100%', 300],
        }}
      >
        {job.assets
          .flatMap((asset) =>
            asset.assetType === 'EXTERNAL_RECORDING_ID' && asset.url
              ? [asset.url]
              : []
          )
          .map((url) => (
            <AudioPlayer
              key={url}
              url={url}
              summaries={job.callSummaries}
              sx={{ width: '100%' }}
            />
          ))}
      </Box>
    </FlexBox>
  </Box>
);

export default Overview;
